export default "__VITE_ASSET__e4d66521__"